import React, { useEffect, useContext, useState } from "react";
import { Container, Navbar, Nav } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../App.scss";
import search from "../../assets/search-logo.svg";
import { Link } from "react-router-dom";
import axios from "axios";
import { UserContext } from "../../use_context";
import NavDropdown from "react-bootstrap/NavDropdown";
import Offcanvas from "react-bootstrap/Offcanvas";
import Slideshow from "./slideshow";

const API_BASE_URL = process.env.REACT_APP_SEARCH_API;

const Preloader = () => (
  <div className="loader-mask">
    <div className="loader"></div>
  </div>
);

const useFadeInOnScroll = () => {
  useEffect(() => {
    const handleFadeIn = () => {
      const fadeSections = document.querySelectorAll(".fade-in-viewport");
      fadeSections.forEach((section) => {
        if (isInViewport(section) && !section.classList.contains("faded-in")) {
          section.classList.add("faded-in");
          section.classList.add("fade-in");
        }
      });
    };

    const isInViewport = (element) => {
      const rect = element.getBoundingClientRect();
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <=
          (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <=
          (window.innerWidth || document.documentElement.clientWidth)
      );
    };

    window.addEventListener("scroll", handleFadeIn);
    handleFadeIn();

    return () => {
      window.removeEventListener("scroll", handleFadeIn);
    };
  }, []);
};

function HomePage() {
  const [offcanvasOpen, setOffcanvasOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const { sliderImages, setSliderImages } = useContext(UserContext);

  // const { sliderImages, setSliderImages } = useContext(UserContext);

  const handleOffcanvasToggle = () => {
    setOffcanvasOpen(!offcanvasOpen);
  };

  const handleOffcanvasClose = () => {
    setOffcanvasOpen(false);
  };

  const getImageDetails = async (imageId) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/media/${imageId}`);
      return response?.data?.source_url || null;
    } catch (error) {
      console.error("Error fetching image details:", error);
      return null;
    }
  };

  // useEffect(() => {
  //   if (sliderImages.length === 0) {
  //     axios
  //       .get(`${API_BASE_URL}/pages/8`)
  //       .then(async (response) => {
  //         const aPIReturnData = response?.data?.acf?.slider || [];
  //         const APIReturnedImages = [];
  //         for (const imageData of aPIReturnData) {
  //           const imageUrl = await getImageDetails(imageData.image);
  //           if (imageUrl) {
  //             APIReturnedImages.push(imageUrl);
  //           }
  //         }
  //         setSliderImages(APIReturnedImages);
  //         setLoading(false);
  //       })
  //       .catch((error) => {
  //         console.error("Error fetching slider images:", error);
  //         alert("Error fetching slider images");
  //         setLoading(false);
  //       });
  //   } else {
  //     setLoading(false);
  //   }
  // }, [sliderImages, setSliderImages]);

  useEffect(() => {
    const fetchSliderImages = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/pages/8`);
        const sliderData = response?.data?.acf?.slider;

        const imagePromises = sliderData.map((imageData) =>
          getImageDetails(imageData.image)
        );

        const imageUrls = await Promise.all(imagePromises);
        const filteredImages = imageUrls.filter(Boolean);

        setSliderImages(filteredImages);
      } catch (error) {
        console.error("Error fetching slider images:", error);
        alert("Error fetching slider images");
      } finally {
        setLoading(false);
      }
    };

    // Only call API if no data is in memory
    if (!sliderImages || sliderImages.length === 0) {
      fetchSliderImages();
    } else {
      setLoading(false);
    }
  }, [sliderImages, setSliderImages]);
  // fetchSliderImages();
  // }, []);

  useFadeInOnScroll();

  useEffect(() => {
    if (!loading) {
      document.body.classList.add("page-loaded");
    }
  }, [loading]);

  return (
    <div>
      {loading && <Preloader />}
      <header className="fixed header-transparent wide-container">
        <Container className="navigation-wrapper" fluid>
          <Navbar expand="lg" className="nav-row first-row">
            <Link to="/homepage" className="text-decoration-none">
              <Navbar.Brand className="brand-logo">
                <img
                  src={search}
                  width="178px"
                  height="33px"
                  alt="React Bootstrap logo"
                />
              </Navbar.Brand>
            </Link>
            <Navbar.Toggle
              aria-controls="basic-navbar-nav"
              onClick={handleOffcanvasToggle}
            />
            <Navbar.Offcanvas
              id="offcanvasNavbar"
              aria-labelledby="offcanvasNavbarLabel"
              placement="end"
              className="home-offcanvas-custom"
              show={offcanvasOpen}
              onHide={handleOffcanvasClose}
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title id="offcanvasNavbarLabel"></Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                <Navbar.Collapse id="basic-navbar-nav" className="ms-auto">
                  <Nav className="menu list-inline custom-ml" id="menu">
                    {/* <NavDropdown.Item href="#action3"> */}
                    <Nav.Link
                      as={Link}
                      to="/Office"
                      className={offcanvasOpen ? "black-text" : "white-text"}
                      // href="/Office"
                    >
                      Office
                    </Nav.Link>
                    {/* </NavDropdown.Item> */}
                    {/* <NavDropdown.Item href="#action3"> */}
                    <Nav.Link
                      as={Link}
                      to="/works"
                      className={offcanvasOpen ? "black-text" : "white-text"}
                      // href="/Works"
                    >
                      Works
                    </Nav.Link>
                    {/* </NavDropdown.Item> */}
                    {/* <NavDropdown.Item href="#action3"> */}
                    <Nav.Link
                      as={Link}
                      to="/News"
                      className={offcanvasOpen ? "black-text" : "white-text"}
                      // href="/News"
                    >
                      News
                    </Nav.Link>
                    {/* </NavDropdown.Item> */}
                    {/* <NavDropdown.Item href="#action3"> */}
                    <Nav.Link
                      as={Link}
                      to="/Contact"
                      className={offcanvasOpen ? "black-text" : "white-text"}
                      // href="/Contact"
                    >
                      Contact
                    </Nav.Link>
                    {/* </NavDropdown.Item> */}
                  </Nav>
                </Navbar.Collapse>
              </Offcanvas.Body>
            </Navbar.Offcanvas>
          </Navbar>
        </Container>
      </header>
      <main>
        <section className="page-hero viewport-height hero-overlay-top">
          {sliderImages && sliderImages.length ? (
            <Slideshow images={sliderImages} interval={3000} />
          ) : null}

          <div className="fog-wrapper absolute inset">
            <div id="foglayer_01" className="fog">
              <div className="image01"></div>
              <div className="image02"></div>
            </div>
            <div id="foglayer_02" className="fog">
              <div className="image01"></div>
              <div className="image02"></div>
            </div>
            <div id="foglayer_03" className="fog">
              <div className="image01"></div>
              <div className="image02"></div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}

export default HomePage;
